exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-datatable.v-table tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.03)}.v-datatable.v-table .width-200{width:200px!important}tr.error td{background-color:#ffd1d1;color:#790000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fa56297","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/enrollment/extemporaneous.vue
// module id = BEHW
// module chunks = 2